import { render, staticRenderFns } from "./Rateplan.vue?vue&type=template&id=6e9ba9d4&"
import script from "./Rateplan.vue?vue&type=script&lang=js&"
export * from "./Rateplan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports